export default __webpack_public_path__ + "static/media/logo-large.87deb987.png";